const LOADING_STATE = {
  IDLE: 'idle',
  PENDING: 'pending',
  FINISHED: 'finished',
  STARED: 'started',
  FAILED: 'failed'
}

export { LOADING_STATE }
